import axios from '../utils/api'

import CONFIG from '../config'
import { isCachedItem } from '../utils/caching'
import {
  FETCH_UNIT_REQUEST, FETCH_UNIT_RESPONSE, FETCH_UNIT_RESPONSE_ERROR,
  SAVE_UNIT_REQUEST, SAVE_UNIT_RESPONSE, SAVE_UNIT_RESPONSE_ERROR,
  LIST_UNITS_REQUEST, LIST_UNITS_RESPONSE,
  LIST_UNIT_DEVICES_REQUEST, LIST_UNIT_DEVICES_RESPONSE,
} from '../constants'

function getLoaderId(action) {
  if (action.id) {
    return action.id
  }
  if (action.unitId) {
    return action.unitId
  }
  if (action.unit && action.unit.id) {
    return action.unit.id
  }
  return ''
}

export function fetchUnit(id) {
  const unitId = parseInt(id, 10)
  // TODO: validation?
  return (dispatch, getState) => {
    if (isCachedItem(getState().units, unitId)) {
      return
    }

    dispatch({
      type: FETCH_UNIT_REQUEST,
      id: unitId,
      getLoaderId,
    })

    axios.get(`${CONFIG.apiBase}/units/${unitId}`).then((response) => {
      dispatch({
        type: FETCH_UNIT_RESPONSE,
        id: unitId,
        getLoaderId,
        unit: response.data.body,
        perms: response.data.perms,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: FETCH_UNIT_RESPONSE_ERROR,
        error,
        id: unitId,
        getLoaderId,
        unit: {
          id: unitId,
        },
        perms: null,
      })
    })
  }
}

export function addUnit(unit) {
  return (dispatch) => {
    dispatch({ type: SAVE_UNIT_REQUEST, unit })
    axios.post(`${CONFIG.apiBase}/units`, unit).then((response) => {
      dispatch({
        type: SAVE_UNIT_RESPONSE,
        unit: response.data.body,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: SAVE_UNIT_RESPONSE_ERROR,
        error,
        unit: {
          id: unit.id,
        },
      })
    })
  }
}

export function saveUnit(unit) {
  return (dispatch) => {
    dispatch({
      type: SAVE_UNIT_REQUEST,
      unit,
      getLoaderId,
    })
    axios.put(`${CONFIG.apiBase}/units/${unit.id}`, unit).then((response) => {
      dispatch({
        type: SAVE_UNIT_RESPONSE,
        unit: response.data.body,
        getLoaderId,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: SAVE_UNIT_RESPONSE_ERROR,
        error,
        unit: {
          id: unit.id,
        },
        getLoaderId,
      })
    })
  }
}

export function listUnits() {
  return (dispatch) => {
    dispatch({ type: LIST_UNITS_REQUEST })

    axios.get(`${CONFIG.apiBase}/units`).then((response) => {
      dispatch({
        type: LIST_UNITS_RESPONSE,
        units: response.data.body,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: LIST_UNITS_RESPONSE,
        error,
        units: [],
      })
    })
  }
}

export function listUnitDevices(id) {
  const unitId = parseInt(id, 10)
  return (dispatch, getState) => {
    if (isCachedItem(getState().devicesByUnit, unitId)) {
      return
    }

    dispatch({
      type: LIST_UNIT_DEVICES_REQUEST,
      unitId,
      getLoaderId,
    })

    axios.get(`${CONFIG.apiBase}/units/${unitId}/devices`).then((response) => {
      dispatch({
        type: LIST_UNIT_DEVICES_RESPONSE,
        unitId,
        getLoaderId,
        devices: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}
